import {
  useColorMode,
  Button,
  Box,
  useColorModeValue,
  Flex,
  Image,
} from "@chakra-ui/react";
import lightSwitch from "../assets/icons/light/themeSwitch.png";
import darkSwitch from "../assets/icons/dark/themeSwitch.png";

export default function ThemeToggle({ ml }: any) {
  const { colorMode, toggleColorMode } = useColorMode();
  const switchSrc = useColorModeValue(lightSwitch, darkSwitch);

  return (
    <Image
      src={switchSrc}
      cursor={"pointer"}
      h={{ base: "32px", lg: "52px" }}
      ml={ml}
      onClick={toggleColorMode}
    />
  );
}
